/*!
 * devextreme-vue
 * Version: 23.1.4
 * Build date: Fri Jul 14 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDxExtensionComponent = void 0;
var vue_1 = require("vue");
var component_1 = require("./component");
var vue_helper_1 = require("./vue-helper");
function initDxExtensionComponent() {
    return (0, vue_1.defineComponent)({
        extends: (0, component_1.initBaseComponent)(),
        mounted: function () {
            this.$el.setAttribute("isExtension", "true");
            var nodeOptions = (0, vue_helper_1.getNodeOptions)(this);
            nodeOptions.$_isExtension = true;
            nodeOptions.$_attachTo = this.attachTo.bind(this);
            if (nodeOptions && nodeOptions.$_hasOwner) {
                return;
            }
            this.attachTo(this.$el);
        },
        methods: {
            attachTo: function (element) {
                this.$_createWidget(element);
            }
        }
    });
}
exports.initDxExtensionComponent = initDxExtensionComponent;
